{
  "languages": {
    "select": "Choisir la langue",
    "english": "En",
    "french": "FR",
    "german": "DE",
    "spanish": "ES",
    "portuguese": "PT"
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "clients": "Clients",
    "myBookings": "Mes Réservations",
    "loginTrainer": "Connexion du formateur",
    "login": "Connexion",
    "logout": "Déconnexion",
    "accountSettings": "Paramètres du compte",
    "changePassword": "Changer le mot de passe",
    "home": "Accueil",
    "pricing": "Tarifs",
    "contact": "Contact",
    "affiliate": "Programme d’affiliation",
    "yogaStudioSoftware": "Logiciel pour studio de yoga",
    "pilatesStudioSoftware": "Logiciel pour studio de pilates",
    "cantienicaStudioSoftware": "Logiciel pour studio CANTIENICA",
    "resources": "Ressources",
    "guides": "Guides",
    "blog": "Blogue"
  },
  "accountSettings": {
    "title": "Paramètres du compte",
    "editTitle": "Modifier le profil",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "updateSuccess": "Profil mis à jour",
    "updateSuccessMessage": "Votre profil a été mis à jour avec succès",
    "firstNameRequired": "Le prénom est requis",
    "lastNameRequired": "Le nom est requis",
    "dangerZone": "Zone dangereuse",
    "deleteAccount": "Supprimer mon compte",
    "deleteWarning": "Cela supprimera définitivement votre compte et toutes les données associées. Cette action est irréversible.",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer votre compte ?",
    "deleteSuccess": "Compte supprimé",
    "deleteSuccessMessage": "Votre compte a été supprimé avec succès.",
    "deleteDialog": {
      "title": "Supprimer mon compte",
      "description": "Êtes-vous sûr de vouloir supprimer votre compte et toutes les données associées ? Cette action est irréversible."
    }
  },
  "password": {
    "changeTitle": "Changer le mot de passe",
    "current": "Mot de passe actuel",
    "new": "Nouveau mot de passe",
    "confirm": "Confirmer le nouveau mot de passe",
    "error": "Erreur",
    "mismatch": "Les nouveaux mots de passe ne correspondent pas",
    "updateSuccess": "Mot de passe mis à jour",
    "updateSuccessMessage": "Votre mot de passe a été mis à jour avec succès",
    "currentPasswordRequired": "Le mot de passe actuel est requis",
    "newPasswordRequired": "Le nouveau mot de passe est requis",
    "confirmPasswordRequired": "La confirmation du mot de passe est requise",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas"
  },
  "classes": {
    "title": "Cours disponibles",
    "bookIntro": "Réservez votre prochaine séance avec nos formateurs experts",
    "bookNow": "Réserver",
    "online": "En ligne",
    "spots": "Places restantes",
    "noClassesAvailableClearFilter": "Aucun cours disponible. Veuillez essayer une autre date ou effacer le filtre pour voir tous les cours disponibles.",
    "noClassesAvailable": "Aucun cours disponible.",
    "confirmBookingTitle": "Cours Réservé !",
    "confirmBookingDescription": "Vous avez réservé avec succès le cours {title} avec {trainer} le {date} à {time}."
  },
  "classForm": {
    "title": "Titre",
    "datetime": "Date/Heure",
    "duration": "Durée",
    "capacity": "Capacité",
    "price": "Prix",
    "currency": "Devise",
    "status": "Statut",
    "statusOptions": {
      "available": "Disponible",
      "canceled": "Annulé",
      "hidden": "Caché"
    },
    "location": "Emplacement",
    "locationOptions": {
      "studio": "Studio",
      "online": "En ligne"
    },
    "trainer": "Formateur",
    "isRecurring": "Cours récurrent",
    "submit": "Soumettre",
    "repeatEvery": "Répéter tous les",
    "repeatPeriod": "Période",
    "repeatPeriodOptions": {
      "week": "Semaine",
      "month": "Mois",
      "year": "Année"
    },
    "maxEvents": "Nombre maximum d'événements",
    "validation": {
      "titleRequired": "Le titre doit comporter au moins 2 caractères.",
      "minCapacity": "La capacité doit être d'au moins 1.",
      "maxEvents": "Le nombre maximum d'événements doit être compris entre 1 et 24."
    },
    "cancelClass": "Annuler le cours",
    "deleteClass": "Supprimer le cours",
    "cancelDialog": {
      "title": "Annuler le cours",
      "description": "Êtes-vous sûr de vouloir annuler ce cours ? Cette action ne peut pas être annulée."
    },
    "deleteDialog": {
      "title": "Supprimer le cours",
      "description": "Êtes-vous sûr de vouloir supprimer ce cours ? Cette action ne peut pas être annulée."
    },
    "cancelSuccess": {
      "title": "Cours annulé",
      "description": "Le cours a été annulé avec succès."
    },
    "deleteSuccess": {
      "title": "Cours supprimé",
      "description": "Le cours a été supprimé avec succès."
    },
    "createSuccess": {
      "title": "Classe créée",
      "description": "La classe a été créée avec succès."
    }
  },
  "classCard": {
    "editClass": "Modifier le cours",
    "enrolled": "inscrit",
    "status": "Statut",
    "at": "à",
    "min": "Min.",
    "spots": "places",
    "location": "Emplacement",
    "trainer": "Formateur",
    "enrolledClients": "Clients inscrits",
    "noEnrolledClients": "Aucun client inscrit.",
    "confirmRemoval": "Confirmer la suppression",
    "confirmRemovalDescription": "Êtes-vous sûr de vouloir retirer {{name}} de la classe ?",
    "clientHistory": "Historique des réservations pour {{name}}",
    "lastBookings": "Voici l'historique des 10 dernières réservations effectuées par ce client.",
    "bookNow": "Réserver maintenant",
    "booked": "Réservé",
    "classFullyBooked": "Complet"
  },
  "bookingSummary": {
    "title": "Résumé de la réservation",
    "description": "Veuillez vérifier les détails de votre réservation de cours",
    "min": "Min.",
    "cancellationPolicy": "Vous pouvez annuler votre réservation jusqu'à 24 heures avant le début du cours sans frais. Pour les annulations effectuées moins de 24 heures avant le début du cours, la totalité des frais sera facturée.",
    "agreeText": "En poursuivant, vous acceptez nos",
    "terms": "Conditions",
    "and": "et",
    "privacyPolicy": "Politique de confidentialité",
    "confirmBooking": "Confirmer la réservation",
    "sessions": "Nombre de séances",
    "selectSessions": "Sélectionnez le nombre de séances",
    "sessionsDescription": "Veuillez sélectionner combien de séances vous souhaitez réserver.",
    "bookingFailedTitle": "Échec de la réservation",
    "bookingFailedDescription": "Impossible de réserver le cours. Veuillez réessayer plus tard.",
    "bookingFullDescription": "Cette séance est complète. Veuillez choisir une autre séance ou une autre date."
  },
  "login": {
    "title": "Connexion",
    "description": "Entrez vos identifiants pour accéder à votre compte",
    "email": "Email",
    "emailPlaceholder": "Entrez votre email",
    "password": "Mot de passe",
    "signIn": "Se connecter",
    "forgotPassword": "Mot de passe oublié ?"
  },
  "terms": {
    "title": "Conditions Générales",
    "scope": {
      "title": "1. Champ d'application",
      "description": "Ces Conditions Générales (\"CG\") s'appliquent à l'utilisation de notre plateforme de réservation de studios de fitness (\"Application\"), qui permet aux studios de fitness de publier leurs cours et aux utilisateurs de les réserver. En vous inscrivant et en utilisant l'Application, vous acceptez d'être lié par ces CG."
    },
    "services": {
      "title": "2. Services Proposés",
      "description": "Notre Application permet aux utilisateurs de :",
      "features": {
        "browse": "Parcourir et réserver des cours de fitness proposés par les studios participants.",
        "manage": "Gérer leurs réservations via leur compte utilisateur."
      },
      "disclaimer": "Nous agissons uniquement en tant que fournisseur de plateforme et ne sommes pas responsables de la qualité, de la disponibilité ou de l'exécution des cours de fitness proposés par des tiers."
    },
    "registration": {
      "title": "3. Inscription et Comptes Utilisateurs",
      "points": {
        "accurateInfo": "Les utilisateurs doivent fournir des informations exactes et à jour lors de l'inscription.",
        "confidentiality": "Chaque utilisateur est responsable de la confidentialité de ses identifiants de compte.",
        "payment": "Cette application est entièrement gratuite pour les utilisateurs. Nous ne facturons aucun frais pour la réservation de cours, et les utilisateurs ne seront jamais sollicités pour effectuer des paiements via l'application."
      }
    },
    "booking": {
      "title": "4. Réservation et Annulation",
      "points": {
        "binding": "Les réservations sont contraignantes une fois confirmées.",
        "cancellationPolicy": "Chaque studio de fitness fixe sa propre politique d'annulation, à laquelle les utilisateurs doivent se conformer.",
        "refunds": "Nous ne sommes pas responsables des remboursements ou des annulations ; ceux-ci sont gérés par les studios de fitness respectifs."
      }
    },
    "responsibilities": {
      "title": "5. Responsabilités des Utilisateurs",
      "points": {
        "lawfulUse": "Les utilisateurs s'engagent à utiliser l'Application de manière légale et non à des fins frauduleuses.",
        "studioRules": "Les utilisateurs doivent respecter les règles et politiques des studios de fitness avec lesquels ils réservent."
      }
    },
    "liability": {
      "title": "6. Responsabilité",
      "points": {
        "injuries": "Nous ne sommes pas responsables des blessures, dommages ou pertes survenant pendant ou à la suite de la participation aux cours réservés.",
        "technicalMalfunctions": "Notre responsabilité pour les dommages dus à des dysfonctionnements techniques de l'Application est limitée aux cas de négligence grave ou d'intention."
      }
    },
    "dataProtection": {
      "title": "7. Protection des Données",
      "points": {
        "gdpr": "Les données des utilisateurs sont traitées conformément à notre Politique de Confidentialité et au RGPD."
      }
    },
    "termination": {
      "title": "8. Résiliation et Suspension de Compte",
      "points": {
        "suspension": "Nous nous réservons le droit de suspendre ou de résilier les comptes qui violent ces CG."
      }
    },
    "governingLaw": {
      "title": "9. Droit Applicable et Règlement des Litiges",
      "points": {
        "germanLaw": "Ces CG sont régies par le droit allemand.",
        "disputeResolution": "Tout litige sera réglé devant les tribunaux allemands."
      }
    }
  },
  "privacy": {
    "title": "Politique de Confidentialité",
    "introduction": {
      "title": "1. Introduction",
      "description": "Cette Politique de Confidentialité explique comment nous collectons, utilisons et protégeons vos données personnelles lors de l'utilisation de notre application conformément au Règlement Général sur la Protection des Données (RGPD) et aux lois allemandes sur la protection des données."
    },
    "dataController": {
      "title": "2. Responsable du Traitement des Données",
      "description": "PraxiPro est le responsable du traitement des données personnelles."
    },
    "dataCollected": {
      "title": "3. Données Collectées",
      "description": "Nous collectons les données suivantes :",
      "points": {
        "account": "Seuls le nom et l'email sont requis pour la création d'un compte.",
        "booking": "Historique des réservations et préférences."
      }
    },
    "purpose": {
      "title": "4. Objectif du Traitement des Données",
      "description": "Vos données sont traitées aux fins suivantes :",
      "points": {
        "account": "Fournir et gérer votre compte.",
        "booking": "Faciliter les réservations de cours.",
        "compliance": "Assurer la conformité avec nos Conditions Générales et améliorer nos services."
      }
    },
    "dataSharing": {
      "title": "5. Partage des Données",
      "points": {
        "fitnessStudios": "Vos données ne sont partagées qu'avec les studios de fitness pour faciliter votre réservation."
      }
    },
    "dataSecurity": {
      "title": "6. Sécurité des Données",
      "description": "Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger vos données contre tout accès non autorisé et toute utilisation abusive."
    },
    "dataRetention": {
      "title": "7. Conservation des Données",
      "points": {
        "retention": "Nous conservons vos données aussi longtemps que nécessaire pour la fourniture de nos services ou comme l'exige la loi.",
        "deletion": "Si vous choisissez de supprimer votre compte, l'application supprimera définitivement toutes les données associées à votre compte. Aucune information personnelle ou donnée connexe ne sera conservée, et vos informations seront complètement effacées de notre système."
      }
    },
    "userRights": {
      "title": "8. Vos Droits",
      "description": "En tant qu'utilisateur, vous disposez des droits suivants en vertu du RGPD :",
      "points": {
        "access": "Droit d'accès, de rectification ou de suppression de vos données personnelles.",
        "object": "Droit de vous opposer au traitement des données.",
        "portability": "Droit à la portabilité des données."
      }
    },
    "contact": {
      "title": "9. Informations de Contact",
      "description": "Pour toute question relative à la confidentialité, veuillez nous contacter à [hello@praxipro.de]."
    },
    "changes": {
      "title": "10. Modifications de Cette Politique",
      "description": "Nous pouvons mettre à jour cette Politique de Confidentialité périodiquement. Les utilisateurs seront informés des changements importants."
    },
    "consent": {
      "description": "En utilisant notre application, vous acceptez les conditions énoncées dans cette Politique de Confidentialité."
    }
  },
  "clientDashboard": {
    "title": "Mes Réservations",
    "bookedClasses": "Mes cours réservés",
    "cancelSuccess": {
      "title": "Réservation annulée",
      "description": "Votre réservation de cours a été annulée avec succès"
    },
    "cancelDialog": {
      "title": "Annuler la réservation",
      "description": "Êtes-vous sûr de vouloir annuler cette réservation ? Cette action ne peut pas être annulée."
    },
    "cannotCancel": "Impossible d'annuler dans les 24h"
  },
  "dashboard": {
    "createNewClass": "Créer un nouveau cours",
    "upcomingClasses": "Cours à venir",
    "historicalClasses": "Cours historiques",
    "createClass": {
      "title": "Créer un nouveau cours",
      "description": "Remplissez les détails de votre nouveau cours.",
      "create": "Créer un cours"
    },
    "editClass": {
      "title": "Modifier le cours",
      "description": "Mettez à jour les détails de votre cours.",
      "update": "Mettre à jour le cours"
    },
    "stats": {
      "totalClasses": "Total des cours",
      "totalStudents": "Total des étudiants"
    }
  },
  "forgotPassword": {
    "title": "Réinitialiser le mot de passe",
    "description": "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "emailLabel": "E-mail",
    "emailPlaceholder": "Entrez votre e-mail",
    "sendResetLinkButton": "Envoyer le lien de réinitialisation",
    "sendingButton": "Envoi en cours...",
    "backToLoginButton": "Retour à la connexion",
    "rememberPassword": "Vous vous souvenez de votre mot de passe ?",
    "toastSuccessTitle": "Lien de réinitialisation envoyé",
    "toastSuccessDescription": "Si un compte existe avec cet e-mail, vous recevrez un lien pour réinitialiser votre mot de passe.",
    "toastErrorTitle": "Erreur lors de la réinitialisation du mot de passe",
    "toastErrorDescription": "Il y a eu un problème pour réinitialiser votre mot de passe. Veuillez réessayer plus tard."
  },
  "resetPassword": {
    "title": "Réinitialiser le mot de passe",
    "description": "Entrez votre nouveau mot de passe pour terminer la réinitialisation.",
    "confirmRegistrationTitle": "Choisir un mot de passe",
    "confirmRegistrationDescription": "Entrez votre nouveau mot de passe pour compléter le processus d'inscription.",
    "newPasswordLabel": "Nouveau mot de passe",
    "confirmPasswordLabel": "Confirmer le mot de passe",
    "sendResetLinkButton": "Envoyer la réinitialisation",
    "sendingButton": "Envoi en cours...",
    "toastPasswordMismatchTitle": "Les mots de passe ne correspondent pas",
    "toastPasswordMismatchDescription": "Veuillez vous assurer que les deux mots de passe sont identiques.",
    "toastSuccessTitle": "Réinitialisation du mot de passe réussie",
    "toastSuccessDescription": "Votre mot de passe a été réinitialisé avec succès.",
    "toastErrorTitle": "Erreur lors de la réinitialisation du mot de passe",
    "toastErrorDescription": "Il y a eu un problème lors de la réinitialisation de votre mot de passe. Veuillez réessayer plus tard."
  },
  "authDialog": {
    "loginTitle": "Se connecter pour réserver un cours",
    "signUpTitle": "S'inscrire pour réserver un cours",
    "loginDescription": "Veuillez vous connecter pour confirmer votre réservation",
    "signUpDescription": "Créez un compte pour réserver des cours",
    "firstName": "Prénom",
    "firstNamePlaceholder": "John",
    "lastName": "Nom",
    "lastNamePlaceholder": "Doe",
    "email": "Email",
    "emailPlaceholder": "john@example.com",
    "password": "Mot de passe",
    "forgotPassword": "Mot de passe oublié ?",
    "loginButton": "Se connecter & Réserver",
    "signUpButton": "S'inscrire & Réserver",
    "switchToSignUp": "Pas encore de compte ? Inscrivez-vous",
    "switchToLogin": "Vous avez déjà un compte ? Connectez-vous",
    "loginFailed": "Échec de la connexion. Veuillez réessayer.",
    "emailAlreadyExists": "Cette adresse e-mail est déjà enregistrée. Veuillez vous connecter à la place. Si vous avez oublié votre mot de passe, utilisez l’option « Mot de passe oublié ».",
    "registrationFailed": "Échec de l'inscription. Veuillez réessayer.",
    "registrationSuccessful": "Inscription réussie ! Veuillez vérifier votre e-mail pour confirmer votre adresse e-mail."
  },
  "common": {
    "class": "Cours",
    "date": "Date",
    "time": "Heure",
    "duration": "Durée",
    "trainer": "Entraîneur",
    "price": "Prix",
    "location": "Lieu",
    "status": "Statut",
    "actions": "Actions",
    "minutes": "minutes",
    "completed": "Terminé",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "close": "Fermer",
    "booked": "Réservé",
    "canceled": "Annulé",
    "keepBooking": "Garder la réservation",
    "confirmCancel": "Oui, annuler",
    "backToClasses": "Retour aux cours",
    "logout": "Déconnexion",
    "pickMonth": "Choisissez un mois",
    "pickDate": "Choisissez une date",
    "clear": "Effacer",
    "remove": "Supprimer",
    "submit": "Soumettre",
    "pleaseWait": "Veuillez patienter..."
  },
  "contactUs": {
    "title": "Besoin d’aide ? Contactez nos experts en logiciels de réservation",
    "getInTouch": "Contactez-nous pour enregistrer votre studio et commencer votre essai gratuit",
    "subHeading": "Nous aimerions avoir de vos nouvelles ! Que ce soit pour une question sur les fonctionnalités, les tarifs ou autre — notre équipe est là pour vous répondre.",
    "fillOutContactForm": "Remplissez le formulaire et nous vous répondrons dès que possible.",
    "name": "Nom",
    "enterName": "Entrez votre nom",
    "email": "Email",
    "enterEmail": "Entrez votre adresse email",
    "studioName": "Nom du studio",
    "enterStudioName": "Entrez le nom du studio",
    "message": "Message",
    "enterMessage": "Entrez votre message",
    "sendMessage": "Envoyer le message",
    "sendingMessage": "Envoi du message",
    "submit": "Envoyer",
    "nameMin": "Le nom doit contenir au moins 2 caractères.",
    "emailInvalid": "Veuillez entrer une adresse email valide.",
    "messageMin": "Le message doit contenir au moins 10 caractères.",
    "requestSent": "Demande envoyée",
    "weWillGetBack": "Nous vous répondrons sous peu !",
    "toastErrorTitle": "Une erreur est survenue",
    "toastErrorDescription": "Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.",
    "alertStudioProfessional": "Ce formulaire est destiné aux professionnels souhaitant enregistrer leur studio.",
    "needSupport": {
      "title": "Besoin d'aide ?",
      "description": "Obtenez des réponses immédiates."
    },
    "feedback": {
      "title": "Un retour ?",
      "description": "Faites-nous en part ici."
    },
    "reportIssue": {
      "title": "Signaler un problème",
      "description": "Bénéficiez d’un support prioritaire."
    },
    "community": {
      "title": "Communauté",
      "description": "Connectez-vous avec d'autres utilisateurs."
    }
  },
  "landing": {
    "title": "Logiciel de gestion de studio pour salles de sport",
    "heroTitle": "Application moderne pour studios de Yoga, Pilates, Physiothérapie et CANTIENICA",
    "heroDescription": "La plateforme tout-en-un pour les propriétaires de studios de fitness afin de gérer les cours, les clients et développer leur entreprise de manière efficace.",
    "ctaText": "Commencer l'essai gratuit",
    "featuresSectionTitle": "Tout ce dont vous avez besoin pour gérer votre studio",
    "featuresSectionDescription": "Des outils puissants conçus spécifiquement pour les propriétaires de studios de fitness",
    "classManagementTitle": "Gestion des Cours",
    "classManagementDescription": "Gérez facilement votre emploi du temps, gérez les réservations et suivez la présence en temps réel",
    "clientManagementTitle": "Gestion des Clients",
    "clientManagementDescription": "Suivez vos clients, leur historique de réservations et gérez les abonnements en un seul endroit",
    "businessAnalyticsTitle": "Analytique des Affaires",
    "businessAnalyticsDescription": "Obtenez des informations sur la performance de votre studio avec des rapports et des analyses détaillées",
    "benefitsSectionTitle": "Développez votre entreprise avec des outils intelligents",
    "benefitsSectionDescription": "Des outils intelligents pour aider votre entreprise à se développer.",
    "benefit1": "Réduisez les absences avec des rappels automatisés",
    "benefit2": "Augmentez les revenus avec des options de tarification flexibles",
    "benefit3": "Gagnez du temps avec la planification automatisée",
    "benefit4": "Améliorez la fidélisation des clients avec des outils d'engagement",
    "benefit5": "Prenez des décisions basées sur les données avec des analyses détaillées",
    "benefit6": "Rationalisez les opérations avec des outils intégrés",
    "ctaSectionTitle": "Prêt à transformer la gestion de votre studio ?",
    "ctaSectionDescription": "Rejoignez les propriétaires de studios à succès qui ont rationalisé leurs opérations avec notre plateforme.",
    "featuredStudiosTitle": "Studios en vedette utilisant FitCalendar",
    "featuredStudiosIntro": "Rejoignez ces entreprises de fitness performantes qui ont transformé leur activité grâce à notre plateforme",
    "physiotherapyPractice": "Cabinet de kinésithérapie",
    "onlineBooking": "Réservation en ligne",
    "howFitCalendarWorksTitle": "Comment fonctionne FitCalendar",
    "howFitCalendarWorksIntro": "Mettez-vous en route en quatre étapes simples",
    "howFitCalendarWorksStep1Title": "Inscription",
    "howFitCalendarWorksStep1Intro": "Créez votre compte et configurez votre profil en quelques minutes",
    "howFitCalendarWorksStep2Title": "Créer",
    "howFitCalendarWorksStep2Intro": "Ajoutez vos cours et préparez votre studio pour les réservations",
    "howFitCalendarWorksStep3Title": "Intégrer",
    "howFitCalendarWorksStep3Intro": "Connectez vos outils existants et ajoutez le lien de réservation à votre site web",
    "howFitCalendarWorksStep4Title": "Développez",
    "howFitCalendarWorksStep4Intro": "Concentrez-vous sur vos clients pendant que nous gérons les tâches administratives",
    "viewPricing": "Voir les tarifs",
    "rating": "Évaluation",
    "happyUsers": "Utilisateurs satisfaits",
    "freeTrial": "Essai gratuit",
    "realTimeDashboard": "Tableau de bord du studio en temps réel",
    "trackYourStudioPerformance": "Suivez les performances de votre studio"
  },
  "pricing": {
    "title": "Tarifs",
    "header": "Formules abordables de logiciel de réservation fitness",
    "subHeader": "Un abonnement abordable pour tout ce dont votre cabinet a besoin — planification des cours, réservations clients et gestion du studio simplifiées.",
    "freeTrial": "Essai gratuit",
    "freeTrialDesc": "Pour les studios testant la plateforme",
    "freeTrialFeatures": [
      "Accès complet pendant 14 jours",
      "Gestion basique du calendrier",
      "Jusqu'à 5 cours par semaine",
      "Profils clients de base"
    ],
    "startFreeTrial": "Commencer l'essai gratuit",
    "standard": "Standard",
    "standardDesc": "Par studio, facturé mensuellement",
    "standardFeatures": [
      "Cours et rendez-vous illimités",
      "Gestion avancée du calendrier",
      "Réservation en ligne pour les clients",
      "Système complet de gestion des clients",
      "Intégration du paiement",
      "Rapports et analyses de base",
      "Support par email"
    ],
    "subscribeNow": "S'abonner maintenant",
    "annual": "Annuel",
    "annualDesc": "Économisez 20 % avec la facturation annuelle",
    "annualFeatures": [
      "Toutes les fonctionnalités Standard",
      "2 mois offerts (équivalent à 16 €/mois)",
      "Support client prioritaire",
      "Rapports et analyses avancés"
    ],
    "subscribeAnnually": "S'abonner annuellement",
    "popularPlan": "Le plus populaire",
    "perMonth": "/mois",
    "perYear": "/an",
    "faqsTitle": "Questions fréquentes",
    "faqsQ1": "Puis-je changer de formule ?",
    "faqsA1": "Oui, vous pouvez passer à une formule annuelle à tout moment. Le retour au mensuel est possible à la fin de l’abonnement annuel.",
    "faqsQ2": "Proposez-vous des réductions pour plusieurs studios ?",
    "faqsA2": "Oui ! Pour les studios ayant plusieurs sites, nous proposons des tarifs dégressifs. Contactez notre équipe commerciale.",
    "faqsQ3": "Quels moyens de paiement acceptez-vous ?",
    "faqsA3": "Nous acceptons toutes les cartes de crédit principales et PayPal. Les virements bancaires sont possibles pour les abonnements annuels.",
    "faqsQ4": "Y a-t-il des frais d'installation ?",
    "faqsA4": "Non, il n’y a aucun frais caché. Votre abonnement couvre tout : installation, hébergement et mises à jour régulières."
  },
  "affiliate": {
    "title": "Programme d'affiliation",
    "heading": "💼 Rejoignez notre programme d'affiliation",
    "description": "Gagnez de l'argent en recommandant des instructeurs de Yoga, Pilates, Fitness, des kinésithérapeutes, des professionnels de CANTIENICA et des coachs en mouvement à FitCalendar. C’est simple, gratifiant et évolutif.",
    "rewardOne": {
      "amount": "💶 96 €",
      "text": "pour chaque nouvel utilisateur qui s’abonne pour un an complet."
    },
    "rewardTwo": {
      "amount": "📅 8 €/mois",
      "text": "pendant un an par utilisateur en cas de paiement mensuel."
    },
    "rewardThree": {
      "title": "🏆 Bonus à vie :",
      "description": "Parrainez plus de 50 utilisateurs payants et recevez",
      "amount": "3 €/mois",
      "forever": "à vie"
    },
    "ctaHeading": "🎉 Commencez dès aujourd’hui",
    "ctaDescription": "Remplissez le formulaire ci-dessous et recevez votre code de parrainage par e-mail. Partagez-le et commencez à gagner !",
    "form": {
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Adresse e-mail",
      "submit": "Obtenir mon code de parrainage",
      "loading": "Inscription en cours..."
    },
    "firstNameMin": "Le prénom est requis",
    "lastNameMin": "Le nom de famille est requis",
    "emailInvalid": "Adresse e-mail invalide"
  },
  "register": {
    "title": "Enregistrement du studio",
    "description": "Enregistrez votre studio et commencez votre essai gratuit",
    "name": "Nom",
    "enterName": "Entrez votre nom",
    "email": "E-mail",
    "enterEmail": "Entrez votre e-mail",
    "studioName": "Nom du studio",
    "enterStudioName": "Entrez le nom du studio",
    "message": "Message",
    "enterMessage": "Entrez votre message",
    "sendMessage": "Envoyer le message",
    "sendingMessage": "Envoi du message",
    "submit": "Envoyer",
    "submitting": "Envoi en cours...",
    "nameMin": "Le nom doit contenir au moins 2 caractères.",
    "emailInvalid": "Veuillez entrer une adresse e-mail valide.",
    "messageMin": "Le message doit contenir au moins 10 caractères.",
    "requestSent": "Demande envoyée",
    "weWillGetBack": "Nous vous contacterons bientôt !",
    "toastErrorTitle": "Erreur survenue",
    "toastErrorDescription": "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard.",
    "alertStudioProfessional": "Ce formulaire est destiné aux professionnels souhaitant enregistrer leur studio."
  },
  "guides": {
    "title": "Bibliothèque de ressources"
  },
  "blog": {
    "title": "Conseils sur le Yoga, le Pilates, le CANTIENICA et le Fitness"
  },
  "clients": {
    "title": "Liste des clients",
    "description": "Gérez vos clients de fitness et consultez leur historique de réservations.",
    "listTitle": "Base de données des clients",
    "searchPlaceholder": "Rechercher par nom ou email...",
    "searchButton": "Rechercher",
    "searching": "Recherche en cours...",
    "table.name": "Nom",
    "table.email": "Email",
    "table.totalBookings": "Total des réservations",
    "table.actions": "Actions",
    "table.class": "Cours",
    "table.date": "Date",
    "table.time": "Heure",
    "table.duration": "Durée",
    "table.price": "Prix",
    "table.status": "Statut",
    "viewClasses": "Voir les réservations",
    "loading": "Chargement...",
    "noClientsFound": "Aucun client trouvé.",
    "searchError.apiTitle": "Erreur API",
    "searchError.apiDescription": "Impossible de charger les données depuis le serveur.",
    "searchError.title": "Avertissement de recherche",
    "minLengthWarning": "Veuillez entrer au moins 3 caractères pour rechercher.",
    "bookingsTitle": "Réservations pour {{name}}",
    "noBookings": "Aucune donnée de réservation disponible.",
    "bookingsDescription": "Ci-dessous l'historique de toutes les réservations effectuées par ce client.",
    "status.booked": "Réservé",
    "status.canceled": "Annulé"
  }
}